// const domen = "http://127.0.0.1:8000"

const domen = 'https://musie.space'

export default domen;
